import React, { useEffect, useState } from "react";
import Common_breadcrumb from "../common-components/common-breadcrumb/Common_breadcrumb";
import Product_Info from "./product_info/Product_Info";
import Order_summery_holder from "./order_summery_holder/Order_summery_holder";
import { useNavigate } from "react-router-dom";
import { getAllCart } from "../../features/cart/cartSlice";
import { useDispatch, useSelector } from "react-redux";
import { FaShoppingCart } from "react-icons/fa";
import { OrderCalculation } from "../../features/order/orderSlice";
import Common_Back_Header from "../common-components/common_back_header/Common_Back_Header";
const Cart = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/proceed-to-Checkout");
  };

  const dispatch = useDispatch();
  // const isSignIn = useSelector((state) => state.auth.is_signin);
  const isSignIn = true;
  const carts = useSelector((state) => state.cart.allCarts);

  useEffect(() => {
    dispatch(getAllCart(isSignIn));
  }, [dispatch]);

  const [CouponData, setCouponData] = useState("");

  const [rewardData, setRewardData] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  // const [orderSumary, setOrderSumary] = useState({});
  const orderSumary = useSelector((state) => state.order.orderCalculation);

  const OrderCalculationData = async (
    coupon_id = null,
    rewardData,
    selectedIds
  ) => {
    const data = {};
    if (coupon_id) {
      data.coupon_id = coupon_id;
    }
    if (selectedIds && selectedIds.length > 0) {
      data.selected_id = selectedIds;
    }
    if (rewardData) {
      data.reward_status = rewardData;
    }
    const res = await dispatch(OrderCalculation(data));
  };

  useEffect(() => {
    if (carts?.data?.data?.length > 0) {
      OrderCalculationData(CouponData?.id, rewardData, selectedIds);
    }
  }, [CouponData, rewardData, selectedIds, carts]);

  return (
    <section className="Cart">
      {/*<Common_breadcrumb
        items={[{ label: "Home", link: "/" }, { label: "Collection", link: "/all-products" },{ label: "Cart" }]}
      />*/}
      {carts?.data?.data?.length > 0 ? (
        <div className="container-fluid">
          <Common_Back_Header backNavigation="/all-products" />
          <div className="row justify-content-center">
            <div className="col-xl-8">
              <Product_Info
                orderSumary={orderSumary}
                carts={carts}
                CouponData={CouponData}
                setCouponData={setCouponData}
                selectedIds={selectedIds}
                setSelectedIds={setSelectedIds}
              />
            </div>

            <div className="col-xl-4 col-md-10 col-sm-8">
              {/* Reward Points row is shown here (no `disable` prop) */}
              <Order_summery_holder
                CouponData={CouponData}
                setRewardData={setRewardData}
                rewardData={rewardData}
                orderSumary={orderSumary}
                btnText={"Proceed To Chekout"}
                OrderCalculationData={OrderCalculationData}
                handleClick={handleClick}
              />
            </div>
          </div>
        </div>
      ) : (
        <div
          style={{
            textAlign: "center",
            padding: "40px",
            color: "#777",
          }}
        >
          <FaShoppingCart
            size={80}
            style={{ marginBottom: "20px", color: "#ccc" }}
          />
          <div style={{ fontWeight: "bold", fontSize: "18px" }}>
            No cart data available
          </div>
        </div>
      )}
    </section>
  );
};

export default Cart;